import { Icon, Tooltip } from '@customerio/pluma-components/react';
import { isObjectOrRelationshipAttribute } from '../utils/item';
import type { DataIndexItemKind } from '../utils/types';

/**
 * The caveat beside the Usage tab: content usage is counted, but a Liquid
 * reference to the attribute is not.
 *
 * Shown only for object and relationship attributes, which is why the copy
 * names one of the two rather than saying "this attribute".
 */

type LiquidCaveatProps = {
  kind: DataIndexItemKind;
};

export function LiquidCaveat({ kind }: LiquidCaveatProps) {
  if (!isObjectOrRelationshipAttribute(kind)) {
    return null;
  }

  const flavour = kind === 'object-relationship-attribute' ? 'relationship' : 'object';

  return (
    <Tooltip content={`At this time, we do not support tracking of ${flavour} attributes in liquid.`} placement="top">
      <Icon name="info" color="information" />
    </Tooltip>
  );
}
